import * as React from "react"
import {AutocompleteAjaxSeeker} from "@ui-seeker/core"

import {BACKEND_APIS} from "@constants"
import {customerID} from "../@signals"


export default function UnmatchedNewProductsCustomerAutocomplete({...props}) {
    return <AutocompleteAjaxSeeker
        urlAjax={`${BACKEND_APIS.UNMATCHED}/new-products/customer`}
        label="Customers"
        placeholder="All Customers"
        value={customerID.value}
        onChange={e => customerID.value = e.target.value}
        {...props}
    />
}